"use client";

import { useState } from "react";
import {
  type CardListSectionCards_Fields,
  type CardListSection_Fields,
} from "~/__generated__/graphql";
import CustomImage from "~/components/CustomImage";
import RichText from "~/components/RichText";
import VideoPopup from "~/components/VideoPopup";

function Card({ card }: { card?: CardListSectionCards_Fields | null }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-white">
      <VideoPopup
        isOpen={isOpen}
        callback={() => setIsOpen(false)}
        videoSourceUrl={card?.video?.link?.url ?? ""}
        isPrismicVideo={false}
      />
      <div onClick={() => setIsOpen(true)} className="relative cursor-pointer">
        <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center bg-black/60">
          <div className="material-icons-round !text-[10rem]">play_circle</div>
        </div>
        <CustomImage
          data={card?.video?.preview}
          className="h-80 object-cover"
        />
      </div>
      {(card?.title || card?.description) && (
        <div className="px-6 pb-4 pt-3">
          {card?.title && (
            <h3 className="text-xl font-medium text-black">{card.title}</h3>
          )}
          {card?.description && (
            <RichText
              field={card.description}
              className="line-clamp-3 text-base font-medium text-black"
            />
          )}
        </div>
      )}
    </div>
  );
}

export default function CardListSection({ cards }: CardListSection_Fields) {
  return (
    <section className="grid grid-cols-1 justify-between gap-5 bg-grey px-6 py-10 md:grid-cols-[repeat(auto-fit,minmax(min(100%,calc(50%-1.25rem)),1fr))] lg:gap-8 lg:px-24 xl:gap-5 xl:px-48">
      {cards?.map((card, i) => <Card key={i} card={card} />)}
    </section>
  );
}
